import React, { useState } from 'react';
import apiClient from '../../../../Services/ApiClient';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import FileUpload from '../../../../Components/Base/FileUpload/FileUpload';
import FormControl from '../../../../Components/Form/FormControl';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useApiClient from '../../../Base/Hooks/useApiClient';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import Loading from '../../../../Components/Loading';
import useRestApiClient from '../../../Base/Hooks/useRestApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	workplaceId: string;
	onSuccess: () => void;
}

type FormValues = {
	file: File[];
};

const validationSchema = yup.object({
	file: yup
		.mixed<File[]>()
		.required('base.shared.document')
		.test(
			'value',
			'base.shared.document',
			value => Array.isArray(value) && value.length > 0,
		),
});

const InsuranceUploadReturnedBatch: React.FC<Props> = ({
	workplaceId,
	onSuccess,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const { displayError } = useApiClient();
	const { showUnexpectedError } = useRestApiClient();
	const { showNotificationSuccess } = useNotification();

	const formMethods = useForm<FormValues>({
		resolver: yupResolver(validationSchema),
		defaultValues: { file: [] },
	});

	const handleChangeFile = (event: any) => {
		const files: File[] = event?.target?.files
			? Array.from(event.target.files)
			: [];

		setSelectedFiles(files);
		formMethods.setValue('file', files, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			const formData = new FormData();

			selectedFiles.forEach(f => formData.append('file', f));
			const response = await apiClient.postMultipart(
				`/workplaces/${workplaceId}/insurance-report/correction`,
				formData,
			);

			if (response.status === 200) {
				onSuccess();
				showNotificationSuccess({
					content: 'component.insuranceUploadReturnedBatch.successMessage',
				});
			} else {
				showUnexpectedError();
			}
		} catch (e) {
			displayError(e);
		} finally {
			setIsLoading(false);
		}
	};

	if (isLoading) return <Loading />;

	return (
		<FormWrapper formMethods={formMethods}>
			<FormControl
				label='base.shared.document'
				name='file'
				onChange={handleChangeFile}
				isRequired={true}>
				<FileUpload isMulti />
			</FormControl>

			<div className='mt-4'>
				<SubmitButton
					title='component.insuranceUploadReturnedBatch.submitButton'
					onSubmit={handleSubmit}
				/>
			</div>
		</FormWrapper>
	);
};

export default InsuranceUploadReturnedBatch;
